import { PartyInterface } from '@app/core/interfaces/party.interface';
import { PersonInterface } from '@app/core/interfaces/person/person.interface';

export class InvolvedPartiesHelper {

    public static CreateParty(data: PartyInterface): any {
        return {
            personen: InvolvedPartiesHelper.CreatePersons(data.personen),
            rol: (data.rol) ? data.rol : null,
            toevoegen_toestaan: (data.toevoegen_toestaan) ? data.toevoegen_toestaan : false,
        };
    }

    public static CreatePerson(data: PersonInterface): any {
        return {
            achternaam: (data.achternaam) ? data.achternaam : null,
            adres_relatie_id: (data.adres_relatie_id) ? data.adres_relatie_id : null,
            adres_relatie_natuurlijk_persoon_versie_id: (data.adres_relatie_natuurlijk_persoon_versie_id)
                ? data.adres_relatie_natuurlijk_persoon_versie_id : null,
            beeindigd_indicatie: (data.beeindigd_indicatie) ? data.beeindigd_indicatie : null,
            beeindigd_indicatie_omschrijving: (data.beeindigd_indicatie_omschrijving) ? data.beeindigd_indicatie_omschrijving : null,
            einddatum: (data.einddatum) ? data.einddatum : null,
            geldigheid_status_code: (data.geldigheid_status_code) ? data.geldigheid_status_code : null,
            ingangsdatum: (data.ingangsdatum) ? data.ingangsdatum : null,
            registratie_medewerker_id: (data.registratie_medewerker_id) ? data.registratie_medewerker_id : null,
            registratie_medewerker_id_omschrijving: (data.registratie_medewerker_id_omschrijving)
                ? data.registratie_medewerker_id_omschrijving : null,
            registratie_organisatie_id: (data.registratie_organisatie_id) ? data.registratie_organisatie_id : null,
            registratie_organisatie_id_omschrijving: (data.registratie_organisatie_id_omschrijving)
                ? data.registratie_organisatie_id_omschrijving : null,
            rol: (data.rol) ? data.rol : null,
            soort_np_code: (data.soort_np_code) ? data.soort_np_code : null,
            soort_np_omschrijving: (data.soort_np_omschrijving) ? data.soort_np_omschrijving : null,
            tussenvoegsels: (data.tussenvoegsels) ? data.tussenvoegsels : null,
            voorletters: (data.voorletters) ? data.voorletters : null,
            handelsnaam: (data.handelsnaam) ? data.handelsnaam : null,
            volledige_naam: (data.voorletters || data.tussenvoegsels || data.achternaam) ?
                InvolvedPartiesHelper.CreateFullName(data.voorletters, data.tussenvoegsels, data.achternaam) : null,
            persoon_type: (data.persoon_type) ? data.persoon_type : null,
        };
    }

    private static CreatePersons(person: PersonInterface[]): PersonInterface[] {
        const array: PersonInterface[] = [];

        if (person) {
            person.forEach(personItem => {
                array.push(InvolvedPartiesHelper.CreatePerson(personItem));
            });
        }

        return array;
    }

    private static CreateFullName(initials: string, tussenvoegsels: string, lastname: string): string {
        if (initials && lastname === null) {
            return initials.toUpperCase();
        }

        if (initials === null && tussenvoegsels && lastname) {
            return `${tussenvoegsels} ${lastname}`;
        }

        if (lastname && initials === null) {
            return lastname;
        }

        if (initials && tussenvoegsels && lastname) {
            return `${initials.toUpperCase()} ${tussenvoegsels} ${lastname}`;
        }

        return `${initials.toUpperCase()} ${lastname}`;
    }
}
